import { css } from "@emotion/react";
import { forwardRef, Ref } from "react";
import {
  Breadcrumb as AriaBreadcrumb,
  BreadcrumbProps as AriaBreadcrumbProps,
} from "react-aria-components";

import { Icon, Icons } from "../icon";

interface BreadcrumbProps extends AriaBreadcrumbProps {}

const breadcrumbCSS = css`
  display: flex;
  align-items: center;

  a {
    color: var(--global-text-color-700);
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 40ch;
    &:hover {
      text-decoration: underline;
    }
  }

  &[data-current],
  &[data-current] a {
    color: var(--global-text-color-900);
    font-weight: 600;
    cursor: default;
    &:hover {
      text-decoration: none;
    }
  }
`;

function Breadcrumb(props: BreadcrumbProps, ref: Ref<HTMLLIElement>) {
  const { children, ...rest } = props;
  return (
    <AriaBreadcrumb css={breadcrumbCSS} {...rest} ref={ref}>
      {({ isCurrent }) => (
        <>
          {children}
          {!isCurrent && <Icon svg={<Icons.ChevronRight />} />}
        </>
      )}
    </AriaBreadcrumb>
  );
}

const _Breadcrumb = forwardRef(Breadcrumb);
export { _Breadcrumb as Breadcrumb };
